<template>
  <label :class="classes">
    <input
      class="toggle-button__input"
      type="checkbox"
      v-model="checkedValue"
      @change="$emit('change', $event.target.checked)"
    />
    <component
      v-if="iconLeft"
      :is="iconLeft"
      :extra-classes="extraIconClasses"
    />

    {{ text }}
  </label>
</template>

<script>
  import Tag from '@/components/icons/Tag'
  import Star from '@/components/icons/Star'

  export default {
    name: 'toggle-button',
    props: {
      text: {
        type: String,
        required: true,
      },
      type: {
        type: String,
        default: 'default',
      },
      isChecked: {
        type: Boolean,
        default: false,
      },
      iconLeft: {
        type: String,
      },
      iconClasses: {
        type: Array,
        default: function () {
          return []
        },
      },
      extraClasses: {
        type: Array,
        default: function () {
          return []
        },
      },
    },
    components: {
      Tag,
      Star,
    },
    data() {
      return {
        checkedValue: false,
      }
    },
    mounted() {
      this.checkedValue = this.isChecked
    },
    updated: function () {
      this.checkedValue = this.isChecked
    },
    computed: {
      classes: function () {
        let classes = ['toggle-button', `toggle-button--${this.type}`]
        if (this.checkedValue) {
          classes.push('toggle-button--checked')
        }
        return classes.concat(this.extraClasses).join(' ')
      },
      extraIconClasses: function () {
        let classes = [
          `toggle-button__icon-${this.iconRight ? 'right' : 'left'}`,
        ]
        return classes.concat(this.iconClasses)
      },
    },
  }
</script>

<style lang="scss">
  .toggle-button {
    $default-color: $grey-dark;
    transition: $transition-base;
    border: 1px solid $grey-lighter;
    border-radius: $border-radius;
    padding: spacer(0.1) spacer(0.5);
    position: relative;
    cursor: pointer;
    color: $default-color;
    margin-right: spacer(0.5);

    &:last-child {
      margin-right: 0;
    }

    .icon {
      width: 0.8em;
      vertical-align: middle;
    }

    &__icon-left {
      margin-right: spacer(0.25);
    }

    &--checked {
      color: $white;
    }

    &--default {
      &.toggle-button--checked {
        background: $default-color;
        border-color: $default-color;
      }
    }

    &--prioritised {
      &.toggle-button--checked {
        background: $error-color;
        border-color: $error-color;
      }
    }

    &__input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }
  }
</style>
